<div class="flex h-full w-full flex-col overflow-hidden bg-white">
  <div class="flex shrink-0 items-start justify-between gap-4 border-b border-neutral-200 px-5 py-4 sm:px-6">
    <div class="min-w-0">
      <h2 class="text-lg font-semibold text-slate-950">Edit columns</h2>
      <p class="mt-1 text-sm text-slate-500">
        Update the collection name and column definitions.
      </p>
    </div>
    <button
      type="button"
      class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-lg text-slate-500 transition hover:bg-slate-100"
      aria-label="Close"
      (click)="close()">
      ×
    </button>
  </div>

  <div class="flex min-h-0 flex-1 flex-col gap-6 overflow-hidden px-5 py-4 sm:px-6">
    <div class="shrink-0">
      <lib-signal-text-field
        label="Collection name"
        placeholder="Customers"
        [value]="name()"
        [debounceValueChange]="false"
        (valueChange)="name.set($event)" />
    </div>

    <div class="flex min-h-0 flex-1 flex-col gap-4 overflow-hidden">
      <div class="flex shrink-0 flex-wrap items-start justify-between gap-3">
        <div>
          <h3 class="text-sm font-semibold text-neutral-900">Columns</h3>
          <p class="mt-0.5 text-xs text-neutral-500">
            Define the fields for this collection.
          </p>
        </div>
        <button
          type="button"
          class="inline-flex cursor-pointer items-center gap-1.5 rounded-lg bg-primary-50 px-3 py-1.5 text-sm font-medium text-primary-700 transition hover:bg-primary-100"
          (click)="addColumn()">
          Add column
        </button>
      </div>

      <div
        class="flex min-h-0 flex-1 flex-col gap-3 overflow-y-auto overscroll-contain pr-1"
        cdkDropList
        (cdkDropListDropped)="onColumnDrop($event)">
        @for (column of columns(); track column.id) {
          <div
            class="shrink-0 rounded-xl border border-neutral-200 bg-white p-3 shadow-sm sm:p-4"
            [attr.data-column-id]="column.id"
            cdkDrag>
            <div class="flex flex-wrap items-center gap-3">
              <button
                type="button"
                cdkDragHandle
                class="flex h-10 w-10 shrink-0 cursor-grab items-center justify-center rounded-lg text-neutral-400 transition hover:bg-neutral-50 hover:text-neutral-700 active:cursor-grabbing"
                aria-label="Reorder column">
                <app-svg-icon src="assets/icons/drag-vertical.svg" [size]="24" />
              </button>

              <div
                [class]="
                  'flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ring-1 ring-black/5 ' +
                  typeChipClass(column.valueType)
                ">
                <app-svg-icon [src]="iconSrcForType(column.valueType)" [size]="18" />
              </div>

              <div class="min-w-44 flex-1 basis-44 sm:min-w-56">
                <lib-signal-text-field
                  label="Label"
                  appearance="ifta"
                  placeholder="e.g. Customer Id"
                  [value]="column.label"
                  [debounceValueChange]="false"
                  (valueChange)="setLabel(column.id, $event)" />
              </div>

              <div class="w-32 shrink-0 sm:w-36">
                <lib-signal-dropdown
                  label="Type"
                  appearance="ifta"
                  [items]="valueTypeOptions"
                  valuePath="value"
                  displayPath="label"
                  [value]="column.valueType"
                  [debounceValueChange]="false"
                  (valueChange)="setValueType(column.id, $event)" />
              </div>

              <lib-signal-radio
                label="Unique"
                groupName="edit-collection-unique-column"
                [optionValue]="column.id"
                [value]="uniqueColumnId()"
                (valueChange)="setUnique($event)" />

              <lib-signal-checkbox
                label="Required"
                [value]="column.required"
                (valueChange)="setRequired(column.id, $event)" />

              <button
                type="button"
                class="inline-flex h-9 w-9 shrink-0 cursor-pointer items-center justify-center rounded-lg border border-neutral-200 text-red-600 transition hover:border-red-200 hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-neutral-200 disabled:hover:bg-transparent"
                aria-label="Delete column"
                [disabled]="columns().length <= 1"
                (click)="removeColumn(column.id)">
                <app-svg-icon src="assets/icons/trash-can-outline.svg" [size]="18" />
              </button>
            </div>

            <div
              *cdkDragPlaceholder
              class="h-20 rounded-xl border border-dashed border-neutral-300 bg-neutral-100/80"></div>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="flex shrink-0 justify-end gap-2 border-t border-neutral-200 px-5 py-4 sm:px-6">
    <lib-signal-button appearance="outline" [fullWidth]="false" (clicked)="close()">
      Cancel
    </lib-signal-button>
    <lib-signal-button [fullWidth]="false" (clicked)="save()">
      Save columns
    </lib-signal-button>
  </div>
</div>
